import { z } from 'zod';
import { RideStatus, RideType, PaymentStatus, PaymentMethod } from './enums.js';
export const RideSchema = z.object({
    id: z.string().uuid(),
    clientId: z.string().uuid(),
    agentId: z.string().uuid().nullable(),
    type: z.nativeEnum(RideType),
    status: z.nativeEnum(RideStatus),
    pickupLat: z.number(),
    pickupLng: z.number(),
    pickupAddress: z.string(),
    dropoffLat: z.number(),
    dropoffLng: z.number(),
    dropoffAddress: z.string(),
    distanceKm: z.number().optional(),
    estimatedDurationMin: z.number().int().optional(),
    priceFcfa: z.number().int().positive(),
    commissionFcfa: z.number().int().nonnegative(),
    agentEarningsFcfa: z.number().int().nonnegative(),
    paymentStatus: z.nativeEnum(PaymentStatus),
    paymentMethod: z.nativeEnum(PaymentMethod).nullable(),
    paymentReference: z.string().nullable(),
    notes: z.string().optional(),
    cancelledBy: z.string().uuid().nullable(),
    cancelReason: z.string().nullable(),
    assignedAt: z.string().datetime().nullable(),
    acceptedAt: z.string().datetime().nullable(),
    pickedUpAt: z.string().datetime().nullable(),
    deliveredAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateRideSchema = z.object({
    type: z.nativeEnum(RideType),
    pickupLat: z.number(),
    pickupLng: z.number(),
    pickupAddress: z.string().min(5).max(200),
    dropoffLat: z.number(),
    dropoffLng: z.number(),
    dropoffAddress: z.string().min(5).max(200),
    notes: z.string().max(500).optional(),
    paymentMethod: z.nativeEnum(PaymentMethod).default(PaymentMethod.CASH),
});
export const AssignRideSchema = z.object({
    agentId: z.string().uuid(),
});
export const UpdateRideStatusSchema = z.object({
    status: z.nativeEnum(RideStatus),
    lat: z.number().optional(),
    lng: z.number().optional(),
});
export const RateRideSchema = z.object({
    rating: z.number().min(1).max(5),
    comment: z.string().max(500).optional(),
});
// Query strings arrive as text: single value, comma list, or repeated key.
// Normalize all three shapes to an array before validating.
const queryEnumArray = (item) => z.preprocess((v) => {
    if (v === undefined || v === null)
        return undefined;
    const list = Array.isArray(v) ? v : String(v).split(',');
    return list.map((s) => String(s).trim()).filter(Boolean);
}, z.array(item).optional());
export const RideSearchSchema = z.object({
    status: queryEnumArray(z.nativeEnum(RideStatus)),
    type: queryEnumArray(z.nativeEnum(RideType)),
    clientId: z.string().uuid().optional(),
    agentId: z.string().uuid().optional(),
    dateFrom: z.string().datetime().optional(),
    dateTo: z.string().datetime().optional(),
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
